import { standardSchemaResolver } from "@hookform/resolvers/standard-schema";
import type { FieldErrors, FieldValues, Resolver } from "react-hook-form";

type SchemaInput = Parameters<typeof standardSchemaResolver>[0];

type StandardOutput<T extends SchemaInput> = NonNullable<
  T["~standard"]["types"]
>["output"] extends FieldValues
  ? NonNullable<T["~standard"]["types"]>["output"]
  : FieldValues;

function translateErrors(errors: FieldErrors, t: (key: string) => string): FieldErrors {
  return Object.fromEntries(
    Object.entries(errors).map(([key, err]) => [
      key,
      err && typeof err === "object" && "message" in err
        ? { ...err, message: t(err.message as string) }
        : translateErrors(err as FieldErrors, t),
    ])
  ) as FieldErrors;
}

export function i18nStandardSchemaResolver<T extends SchemaInput>(
  schema: T,
  t: (key: string) => string
): Resolver<StandardOutput<T>> {
  const resolve = standardSchemaResolver(schema);
  return (async (...args: Parameters<typeof resolve>) => {
    const result = await resolve(...args);
    return { ...result, errors: translateErrors(result.errors, t) };
  }) as unknown as Resolver<StandardOutput<T>>;
}
